var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_59463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 26.875H34.6401V28.1875H36.0001V26.875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 25.5625H34.6401V26.875H36.0001V25.5625Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 24.25H34.6401V25.5625H36.0001V24.25Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 22.9375H34.6401V24.25H36.0001V22.9375Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 21.625H34.6401V22.9375H36.0001V21.625Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 20.3125H34.6401V21.625H36.0001V20.3125Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6398 26.875H33.2798V28.1875H34.6398V26.875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6398 25.5625H33.2798V26.875H34.6398V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6398 24.25H33.2798V25.5625H34.6398V24.25Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6398 22.9375H33.2798V24.25H34.6398V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6398 21.625H33.2798V22.9375H34.6398V21.625Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6398 20.3125H33.2798V21.625H34.6398V20.3125Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6398 19H33.2798V20.3125H34.6398V19Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6398 17.6875H33.2798V19H34.6398V17.6875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2799 26.875H31.9199V28.1875H33.2799V26.875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2799 25.5625H31.9199V26.875H33.2799V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2799 24.25H31.9199V25.5625H33.2799V24.25Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2799 22.9375H31.9199V24.25H33.2799V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2799 21.625H31.9199V22.9375H33.2799V21.625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2799 20.3125H31.9199V21.625H33.2799V20.3125Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2799 19H31.9199V20.3125H33.2799V19Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2799 17.6875H31.9199V19H33.2799V17.6875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2799 16.375H31.9199V17.6875H33.2799V16.375Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9201 26.875H30.5601V28.1875H31.9201V26.875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9201 25.5625H30.5601V26.875H31.9201V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9201 24.25H30.5601V25.5625H31.9201V24.25Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9201 22.9375H30.5601V24.25H31.9201V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9201 21.625H30.5601V22.9375H31.9201V21.625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9201 20.3125H30.5601V21.625H31.9201V20.3125Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9201 19H30.5601V20.3125H31.9201V19Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9201 17.6875H30.5601V19H31.9201V17.6875Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9201 16.375H30.5601V17.6875H31.9201V16.375Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5602 26.875H29.2002V28.1875H30.5602V26.875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5602 25.5625H29.2002V26.875H30.5602V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5602 24.25H29.2002V25.5625H30.5602V24.25Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5602 22.9375H29.2002V24.25H30.5602V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5602 21.625H29.2002V22.9375H30.5602V21.625Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5602 20.3125H29.2002V21.625H30.5602V20.3125Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5602 19H29.2002V20.3125H30.5602V19Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5602 17.6875H29.2002V19H30.5602V17.6875Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5602 16.375H29.2002V17.6875H30.5602V16.375Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1998 26.875H27.8398V28.1875H29.1998V26.875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1998 25.5625H27.8398V26.875H29.1998V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1998 24.25H27.8398V25.5625H29.1998V24.25Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1998 22.9375H27.8398V24.25H29.1998V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1998 21.625H27.8398V22.9375H29.1998V21.625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1998 20.3125H27.8398V21.625H29.1998V20.3125Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1998 19H27.8398V20.3125H29.1998V19Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1998 17.6875H27.8398V19H29.1998V17.6875Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1998 16.375H27.8398V17.6875H29.1998V16.375Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.84 28.1875H26.48V29.5H27.84V28.1875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.84 26.875H26.48V28.1875H27.84V26.875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.84 25.5625H26.48V26.875H27.84V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.84 24.25H26.48V25.5625H27.84V24.25Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.84 22.9375H26.48V24.25H27.84V22.9375Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.84 21.625H26.48V22.9375H27.84V21.625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.84 20.3125H26.48V21.625H27.84V20.3125Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.84 19H26.48V20.3125H27.84V19Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.84 17.6875H26.48V19H27.84V17.6875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.84 16.375H26.48V17.6875H27.84V16.375Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4801 28.1875H25.1201V29.5H26.4801V28.1875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4801 26.875H25.1201V28.1875H26.4801V26.875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4801 25.5625H25.1201V26.875H26.4801V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4801 24.25H25.1201V25.5625H26.4801V24.25Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4801 22.9375H25.1201V24.25H26.4801V22.9375Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4801 21.625H25.1201V22.9375H26.4801V21.625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4801 20.3125H25.1201V21.625H26.4801V20.3125Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4801 19H25.1201V20.3125H26.4801V19Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4801 17.6875H25.1201V19H26.4801V17.6875Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4801 16.375H25.1201V17.6875H26.4801V16.375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4801 15.0625H25.1201V16.375H26.4801V15.0625Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4801 13.75H25.1201V15.0625H26.4801V13.75Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4801 12.4375H25.1201V13.75H26.4801V12.4375Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1198 28.1875H23.7598V29.5H25.1198V28.1875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1198 26.875H23.7598V28.1875H25.1198V26.875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1198 25.5625H23.7598V26.875H25.1198V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1198 24.25H23.7598V25.5625H25.1198V24.25Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1198 22.9375H23.7598V24.25H25.1198V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1198 21.625H23.7598V22.9375H25.1198V21.625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1198 20.3125H23.7598V21.625H25.1198V20.3125Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1198 19H23.7598V20.3125H25.1198V19Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1198 17.6875H23.7598V19H25.1198V17.6875Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1198 16.375H23.7598V17.6875H25.1198V16.375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1198 15.0625H23.7598V16.375H25.1198V15.0625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1198 13.75H23.7598V15.0625H25.1198V13.75Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1198 12.4375H23.7598V13.75H25.1198V12.4375Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1198 11.125H23.7598V12.4375H25.1198V11.125Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7599 28.1875H22.3999V29.5H23.7599V28.1875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7599 26.875H22.3999V28.1875H23.7599V26.875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7599 25.5625H22.3999V26.875H23.7599V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7599 24.25H22.3999V25.5625H23.7599V24.25Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7599 22.9375H22.3999V24.25H23.7599V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7599 21.625H22.3999V22.9375H23.7599V21.625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7599 20.3125H22.3999V21.625H23.7599V20.3125Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7599 19H22.3999V20.3125H23.7599V19Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7599 17.6875H22.3999V19H23.7599V17.6875Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7599 16.375H22.3999V17.6875H23.7599V16.375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7599 15.0625H22.3999V16.375H23.7599V15.0625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7599 13.75H22.3999V15.0625H23.7599V13.75Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7599 12.4375H22.3999V13.75H23.7599V12.4375Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7599 11.125H22.3999V12.4375H23.7599V11.125Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7599 9.8125H22.3999V11.125H23.7599V9.8125Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 28.1875H21.04V29.5H22.4V28.1875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 26.875H21.04V28.1875H22.4V26.875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 25.5625H21.04V26.875H22.4V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 24.25H21.04V25.5625H22.4V24.25Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 22.9375H21.04V24.25H22.4V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 21.625H21.04V22.9375H22.4V21.625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 20.3125H21.04V21.625H22.4V20.3125Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 19H21.04V20.3125H22.4V19Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 17.6875H21.04V19H22.4V17.6875Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 16.375H21.04V17.6875H22.4V16.375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 15.0625H21.04V16.375H22.4V15.0625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 13.75H21.04V15.0625H22.4V13.75Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 12.4375H21.04V13.75H22.4V12.4375Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 11.125H21.04V12.4375H22.4V11.125Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 9.8125H21.04V11.125H22.4V9.8125Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 28.1875H19.6802V29.5H21.0402V28.1875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 26.875H19.6802V28.1875H21.0402V26.875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 25.5625H19.6802V26.875H21.0402V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 24.25H19.6802V25.5625H21.0402V24.25Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 22.9375H19.6802V24.25H21.0402V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 21.625H19.6802V22.9375H21.0402V21.625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 20.3125H19.6802V21.625H21.0402V20.3125Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 19H19.6802V20.3125H21.0402V19Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 17.6875H19.6802V19H21.0402V17.6875Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 16.375H19.6802V17.6875H21.0402V16.375Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 15.0625H19.6802V16.375H21.0402V15.0625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 13.75H19.6802V15.0625H21.0402V13.75Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 12.4375H19.6802V13.75H21.0402V12.4375Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 11.125H19.6802V12.4375H21.0402V11.125Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 9.8125H19.6802V11.125H21.0402V9.8125Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 28.1875H18.3198V29.5H19.6798V28.1875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 26.875H18.3198V28.1875H19.6798V26.875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 25.5625H18.3198V26.875H19.6798V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 24.25H18.3198V25.5625H19.6798V24.25Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 22.9375H18.3198V24.25H19.6798V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 21.625H18.3198V22.9375H19.6798V21.625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 20.3125H18.3198V21.625H19.6798V20.3125Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 19H18.3198V20.3125H19.6798V19Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 17.6875H18.3198V19H19.6798V17.6875Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 16.375H18.3198V17.6875H19.6798V16.375Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 15.0625H18.3198V16.375H19.6798V15.0625Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 13.75H18.3198V15.0625H19.6798V13.75Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 12.4375H18.3198V13.75H19.6798V12.4375Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 11.125H18.3198V12.4375H19.6798V11.125Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 9.8125H18.3198V11.125H19.6798V9.8125Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 8.5H18.3198V9.8125H19.6798V8.5Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32 28.1875H16.96V29.5H18.32V28.1875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32 26.875H16.96V28.1875H18.32V26.875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32 25.5625H16.96V26.875H18.32V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32 24.25H16.96V25.5625H18.32V24.25Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32 22.9375H16.96V24.25H18.32V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32 21.625H16.96V22.9375H18.32V21.625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32 20.3125H16.96V21.625H18.32V20.3125Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32 19H16.96V20.3125H18.32V19Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32 17.6875H16.96V19H18.32V17.6875Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32 16.375H16.96V17.6875H18.32V16.375Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32 15.0625H16.96V16.375H18.32V15.0625Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32 13.75H16.96V15.0625H18.32V13.75Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32 12.4375H16.96V13.75H18.32V12.4375Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32 11.125H16.96V12.4375H18.32V11.125Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32 9.8125H16.96V11.125H18.32V9.8125Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.32 8.5H16.96V9.8125H18.32V8.5Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9601 28.1875H15.6001V29.5H16.9601V28.1875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9601 26.875H15.6001V28.1875H16.9601V26.875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9601 25.5625H15.6001V26.875H16.9601V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9601 24.25H15.6001V25.5625H16.9601V24.25Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9601 22.9375H15.6001V24.25H16.9601V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9601 21.625H15.6001V22.9375H16.9601V21.625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9601 20.3125H15.6001V21.625H16.9601V20.3125Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9601 19H15.6001V20.3125H16.9601V19Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9601 17.6875H15.6001V19H16.9601V17.6875Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9601 16.375H15.6001V17.6875H16.9601V16.375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9601 15.0625H15.6001V16.375H16.9601V15.0625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9601 13.75H15.6001V15.0625H16.9601V13.75Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9601 12.4375H15.6001V13.75H16.9601V12.4375Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9601 11.125H15.6001V12.4375H16.9601V11.125Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9601 9.8125H15.6001V11.125H16.9601V9.8125Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9601 8.5H15.6001V9.8125H16.9601V8.5Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 28.1875H14.2402V29.5H15.6002V28.1875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 26.875H14.2402V28.1875H15.6002V26.875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 25.5625H14.2402V26.875H15.6002V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 24.25H14.2402V25.5625H15.6002V24.25Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 22.9375H14.2402V24.25H15.6002V22.9375Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 21.625H14.2402V22.9375H15.6002V21.625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 20.3125H14.2402V21.625H15.6002V20.3125Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 19H14.2402V20.3125H15.6002V19Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 17.6875H14.2402V19H15.6002V17.6875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 16.375H14.2402V17.6875H15.6002V16.375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 15.0625H14.2402V16.375H15.6002V15.0625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 13.75H14.2402V15.0625H15.6002V13.75Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 12.4375H14.2402V13.75H15.6002V12.4375Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 11.125H14.2402V12.4375H15.6002V11.125Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 9.8125H14.2402V11.125H15.6002V9.8125Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 8.5H14.2402V9.8125H15.6002V8.5Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2399 28.1875H12.8799V29.5H14.2399V28.1875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2399 26.875H12.8799V28.1875H14.2399V26.875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2399 25.5625H12.8799V26.875H14.2399V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2399 24.25H12.8799V25.5625H14.2399V24.25Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2399 22.9375H12.8799V24.25H14.2399V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2399 21.625H12.8799V22.9375H14.2399V21.625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2399 20.3125H12.8799V21.625H14.2399V20.3125Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2399 19H12.8799V20.3125H14.2399V19Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2399 17.6875H12.8799V19H14.2399V17.6875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2399 16.375H12.8799V17.6875H14.2399V16.375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2399 15.0625H12.8799V16.375H14.2399V15.0625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2399 13.75H12.8799V15.0625H14.2399V13.75Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2399 12.4375H12.8799V13.75H14.2399V12.4375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2399 11.125H12.8799V12.4375H14.2399V11.125Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.88 28.1875H11.52V29.5H12.88V28.1875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.88 26.875H11.52V28.1875H12.88V26.875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.88 25.5625H11.52V26.875H12.88V25.5625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.88 24.25H11.52V25.5625H12.88V24.25Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.88 22.9375H11.52V24.25H12.88V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.88 21.625H11.52V22.9375H12.88V21.625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.88 20.3125H11.52V21.625H12.88V20.3125Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.88 19H11.52V20.3125H12.88V19Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.88 17.6875H11.52V19H12.88V17.6875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.88 16.375H11.52V17.6875H12.88V16.375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.88 15.0625H11.52V16.375H12.88V15.0625Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.88 13.75H11.52V15.0625H12.88V13.75Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.88 12.4375H11.52V13.75H12.88V12.4375Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5202 28.1875H10.1602V29.5H11.5202V28.1875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5202 26.875H10.1602V28.1875H11.5202V26.875Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5202 25.5625H10.1602V26.875H11.5202V25.5625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5202 24.25H10.1602V25.5625H11.5202V24.25Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5202 22.9375H10.1602V24.25H11.5202V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5202 21.625H10.1602V22.9375H11.5202V21.625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5202 20.3125H10.1602V21.625H11.5202V20.3125Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5202 19H10.1602V20.3125H11.5202V19Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5202 17.6875H10.1602V19H11.5202V17.6875Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5202 16.375H10.1602V17.6875H11.5202V16.375Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5202 15.0625H10.1602V16.375H11.5202V15.0625Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1598 28.1875H8.7998V29.5H10.1598V28.1875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1598 26.875H8.7998V28.1875H10.1598V26.875Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1598 25.5625H8.7998V26.875H10.1598V25.5625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1598 24.25H8.7998V25.5625H10.1598V24.25Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1598 22.9375H8.7998V24.25H10.1598V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1598 21.625H8.7998V22.9375H10.1598V21.625Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1598 20.3125H8.7998V21.625H10.1598V20.3125Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1598 19H8.7998V20.3125H10.1598V19Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1598 17.6875H8.7998V19H10.1598V17.6875Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1598 16.375H8.7998V17.6875H10.1598V16.375Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79994 28.1875H7.43994V29.5H8.79994V28.1875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79994 26.875H7.43994V28.1875H8.79994V26.875Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79994 25.5625H7.43994V26.875H8.79994V25.5625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79994 24.25H7.43994V25.5625H8.79994V24.25Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79994 22.9375H7.43994V24.25H8.79994V22.9375Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79994 21.625H7.43994V22.9375H8.79994V21.625Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79994 20.3125H7.43994V21.625H8.79994V20.3125Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79994 19H7.43994V20.3125H8.79994V19Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79994 17.6875H7.43994V19H8.79994V17.6875Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79994 16.375H7.43994V17.6875H8.79994V16.375Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44008 26.875H6.08008V28.1875H7.44008V26.875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44008 25.5625H6.08008V26.875H7.44008V25.5625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44008 24.25H6.08008V25.5625H7.44008V24.25Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44008 22.9375H6.08008V24.25H7.44008V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44008 21.625H6.08008V22.9375H7.44008V21.625Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44008 20.3125H6.08008V21.625H7.44008V20.3125Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44008 19H6.08008V20.3125H7.44008V19Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44008 17.6875H6.08008V19H7.44008V17.6875Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44008 16.375H6.08008V17.6875H7.44008V16.375Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08021 25.5625H4.72021V26.875H6.08021V25.5625Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08021 24.25H4.72021V25.5625H6.08021V24.25Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08021 22.9375H4.72021V24.25H6.08021V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08021 21.625H4.72021V22.9375H6.08021V21.625Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08021 20.3125H4.72021V21.625H6.08021V20.3125Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08021 19H4.72021V20.3125H6.08021V19Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08021 17.6875H4.72021V19H6.08021V17.6875Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71986 24.25H3.35986V25.5625H4.71986V24.25Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71986 22.9375H3.35986V24.25H4.71986V22.9375Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71986 21.625H3.35986V22.9375H4.71986V21.625Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71986 20.3125H3.35986V21.625H4.71986V20.3125Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71986 19H3.35986V20.3125H4.71986V19Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36 22.9375H2V24.25H3.36V22.9375Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36 21.625H2V22.9375H3.36V21.625Z",
    fill: "#21201E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_59463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 21,
    fill: "white",
    transform: "translate(2 8.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStone);
export default __webpack_public_path__ + "static/media/stone.a87009a1c9b471342ffee22c84e19e68.svg";
export { ForwardRef as ReactComponent };